import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  desktopInstructions: {
    defaultMessage: 'You will finalize the payment with the BankID app in the next steps',
    id: 'SubmitCredentialsScreenBankID.desktopInstructions',
  },
});
